import { engageDomain } from './clientDomainPath';
import { isLoadedWithGlammerDomain } from './isLoadedWithGlammerDomain';

export const redirectToEngageDomain = (isPWA?: boolean) => {
  const target = new URL(window.location.href.replace(window.location.hostname, engageDomain));

  if (isLoadedWithGlammerDomain()) {
    target.searchParams.set('domainRedirect', 'true');

    if (isPWA) {
      target.searchParams.set('isPWA', 'true');
    }
  }

  window.location.replace(target.href);
};
